import React from 'react';
import ArrowLink from '~/components/ui/ArrowLink';
import Panel from '~/components/ui/Panel';
import { OfficeSummary } from '~/types/Office';

type CompanyOfficesListPanelProps = {
  companyName: string;
  offices: OfficeSummary[];
};

const CompanyOfficesListPanel: React.FC<CompanyOfficesListPanelProps> = ({
  companyName,
  offices,
}) => {
  if (!offices || offices.length < 1) {
    return null;
  }
  
  return (
    <Panel>
      <h2 className="mb-6 font-avantgarde text-lg font-bold text-blue-700 md:text-2xl">
        Vestigingen van {companyName}
      </h2>
      <ul
        className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3"
        role="list"
      >
        {offices?.map(({ name, slug, address }) => (
          <li key={slug} className="col-span-1">
            <ArrowLink
              href={`/advies/${address.zipcode}/${slug}`}
              textClassName="md:text-base"
            >
              {name}
            </ArrowLink>
          </li>
        ))}
      </ul>
    </Panel>
  );
};

export default CompanyOfficesListPanel;
